<template>
  <div class="opinion">
    <div class="main_box">
      <p class="title">意见反馈</p>
      <div class="form">
        <el-form ref="form" label-width="100px">
          <el-form-item label="系统评价：">
            <el-rate v-model="star"></el-rate>
          </el-form-item>
          <el-form-item class="box" label="意见反馈：">
            <el-input type="textarea" maxlength="255" id="input-area" placeholder="欢迎您提出宝贵的意见"
                      v-model="opinion"></el-input>
            <span class="tips">{{ opinion.length + '/' }}255字</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="footerBtn">
        <div>
          <span @click="submit">提交</span>
          <span @click="clear">清空</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {addFeedback} from '@/api/student'

export default {
  data() {
    return {
      star: 0,
      opinion: ''
    }
  },
  methods: {
    // 清空内容
    clear() {
      this.star = 0
      this.opinion = ''
    },
    // 提交内容
    submit() {
      if (!this.star) {
        this.$message.warning('请最少选择一颗星')
        return false
      }
      if (!this.opinion || this.opinion.length < 10 || this.opinion.length > 255) {
        this.$message.warning('请填写10至255个字的意见')
        return false
      }
      this.$confirm('请核对提交信息，是否确认？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addFeedback({
          xgr: this.$store.state.userInfo.yhid,
          cjr: this.$store.state.userInfo.yhid,
          fkyj: this.opinion,
          xsid: this.$store.state.userInfo.yhid,
          xtpj: this.star,
          zhid: this.$store.state.userInfo.zhid,
          xsmc: this.$store.state.userInfo.realname,
          yycdid: this.$store.state.yycdid
        }).then(res => {
          if (res.success) {
            this.clear()
            this.$message.success('提交成功')
          } else {
            this.$message.error(res.resultDesc)
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.opinion {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .main_box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;

    .title {
      width: 100%;
      height: 3vw;
      color: #333;
      font-weight: bold;
      font-size: 1.3vw;
      line-height: 3vw;
      text-align: center;
    }

    .footerBtn {
      width: 100%;
      height: calc(100% - 22vw);
      position: relative;

      div {
        display: inline-block;
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        span {
          display: block;
          float: left;
          width: 7vw;
          height: 2.5vw;
          border-radius: 32px;
          text-align: center;
          line-height: 2.5vw;
          font-size: 1.1vw;
          cursor: pointer;
        }

        span:nth-child(1) {
          background: #5990FF;
          color: #fff;
          margin-right: 2vw;
        }

        span:nth-child(2) {
          background: #D9E6FF;
          color: #333;
        }
      }
    }
  }

  .box {
    position: relative;

    .tips {
      position: absolute;
      bottom: 0;
      right: 2vw;
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .opinion {
    width: calc(100% - 80px);
    padding: 0 12px;
    height: 100%;
    overflow-y: auto;

    .main_box {
      background: #fff;
      border-radius: 16px;
      padding: 24px 20px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      box-shadow: 0px 4px 20px 0px rgba(89, 144, 255, 0.15);

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 28px;
        padding-bottom: 12px;
        border-bottom: 2px solid #5990ff;
        display: inline-block;
        width: auto;
        align-self: center;
      }

      .form {
        flex: 1;
        width: 100%;

        .el-form {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 24px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          ::v-deep  .el-form-item__label {
            font-size: 15px;
            font-weight: 500;
            color: #333;
            text-align: left;
            padding: 0 0 10px 0;
            width: auto !important;
            line-height: 1.4;
          }

          ::v-deep  .el-form-item__content {
            width: 100% !important;
            margin-left: 0 !important;
          }
        }
      }

      .footerBtn {
        margin-top: 16px;
        padding-top: 8px;

        div {
          display: flex;
          justify-content: center;
          gap: 20px;

          span {
            width: 120px;
            height: 44px;
            line-height: 44px;
            font-size: 16px;
            border-radius: 44px;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;

            &:active {
              transform: scale(0.96);
            }
          }

          span:nth-child(1) {
            background: linear-gradient(135deg, #5990ff, #7aabff);
            color: #fff;
            box-shadow: 0 4px 12px rgba(89, 144, 255, 0.3);
          }

          span:nth-child(2) {
            background: #f5f7fa;
            color: #666;
            border: 1px solid #e4e7ed;
          }
        }
      }
    }

    .box {
      position: relative;

      .tips {
        position: absolute;
        bottom: -20px;
        right: 12px;
        font-size: 12px;
        color: #999;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .opinion {
    width: calc(100% - 65px);
    padding: 0 10px;
    height: 100%;

    .main_box {
      padding: 20px 16px;

      .title {
        font-size: 18px;
        margin-bottom: 22px;
      }

      .form {
        .el-form-item {
          margin-bottom: 20px;

          ::v-deep  .el-form-item__label {
            font-size: 14px;
            padding-bottom: 8px;
          }
        }
      }

      .footerBtn div {
        gap: 15px;

        span {
          width: 110px;
          height: 42px;
          line-height: 42px;
          font-size: 15px;
        }
      }
    }

    .box .tips {
      font-size: 11px;
      bottom: -10px;
      right: 10px;
    }
  }
}
</style>
<style lang="scss">
.opinion {
  .el-rate__item {
    font-size: 30px;
  }

  .el-form-item {
    margin-bottom: 1vw;
  }

  .el-textarea {
    height: 15vw;

    .el-textarea__inner {
      height: 100%;
    }
  }

  .el-textarea__inner {
    height: 15vw;
    background: #F9F9F9;
  }

  #input-area::-webkit-input-placeholder {
    color: #999999;
    font-size: 1.2vw;
    text-align: center;
    line-height: 12vw;
  }
}

@media screen and (max-width: 768px) {
  .el-message-box {
    width: 85% !important;
    max-width: 320px !important;
    border-radius: 20px !important;
    padding: 0 !important;
    overflow: hidden !important;
    background: #fff !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;

    .el-message-box__header {
      background: linear-gradient(135deg, #5990ff, #7aabff) !important;
      padding: 20px 20px !important;
      margin: 0 !important;
      text-align: center !important;

      .el-message-box__title {
        font-size: 18px !important;
        font-weight: 600 !important;
        color: #fff !important;
      }

      .el-message-box__headerbtn {
        top: 50% !important;
        right: 16px !important;
        transform: translateY(-50%) !important;

        .el-message-box__close {
          font-size: 20px !important;
          color: #fff !important;
          font-weight: normal !important;

          &:hover {
            color: rgba(255, 255, 255, 0.8) !important;
          }
        }
      }
    }

    .el-message-box__content {
      padding: 30px !important;
      font-size: 16px !important;
      color: #333 !important;
      line-height: 1.5 !important;
      text-align: center !important;
      background: #fff !important;
    }

    .el-message-box__message p {
      font-size: 2.4vw;
      padding-bottom: 6px;
    }

    .el-icon-warning {
      width: 5vw;
      height: 5vw;
      top: -48px;
    }

    .el-message-box__btns {
      padding: 8px 24px 28px !important;
      display: flex !important;
      justify-content: center !important;
      gap: 16px !important;
      background: #fff !important;

      .el-button {
        width: 110px !important;
        height: 44px !important;
        padding: 0 !important;
        margin: 0 !important;
        border-radius: 44px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        cursor: pointer !important;
        transition: all 0.2s ease !important;

        &:active {
          transform: scale(0.96);
        }
      }

      .el-button:first-child {
        background: #f5f5f5 !important;
        border: 1px solid #e0e0e0 !important;
        color: #666 !important;

        &:active {
          background: #e8e8e8 !important;
        }
      }

      .el-button:last-child {
        background: linear-gradient(135deg, #5990ff, #7aabff) !important;
        border: none !important;
        color: #fff !important;
        box-shadow: 0 4px 12px rgba(89, 144, 255, 0.4) !important;

        &:active {
          background: linear-gradient(135deg, #407ce6, #5990ff) !important;
        }
      }
    }
  }
  .opinion {
    .el-rate {
      display: flex;
      justify-content: center;
      gap: 8px;
    }

    .el-rate__item {
      font-size: 32px;
      margin: 0;
    }

    .el-rate__icon {
      transition: transform 0.2s;
    }

    .el-textarea {
      width: 100%;
      height: 160px;

      .el-textarea__inner {
        height: 100%;
        font-size: 15px;
        line-height: 1.5;
        padding: 12px 15px;
        border-radius: 12px;
        border: 1px solid #e4e7ed;
        background: #fafcff;
        resize: vertical;

        &:focus {
          border-color: #5990ff;
          box-shadow: 0 0 0 2px rgba(89, 144, 255, 0.1);
        }
      }
    }

    #input-area::-webkit-input-placeholder {
      font-size: 14px;
      color: #aaa;
      text-align: left;
    }
  }
}

@media screen and (max-width: 480px) {
  .el-message-box {
    width: 90% !important;
    max-width: 280px !important;

    .el-message-box__header {
      padding: 20px 16px !important;
      .el-message-box__title span{
        font-size: 16px !important;
      }

      .el-message-box__headerbtn {
        right: 12px !important;

        .el-message-box__close {
          font-size: 18px !important;
        }
      }
    }

    .el-message-box__content {
      padding: 30px !important;
      font-size: 15px !important;
    }

    .el-message-box__message p {
      font-size: 3.9vw;
      padding-bottom: 6px;
    }

    .el-icon-warning {
      width: 8vw;
      height: 8vw;
      top: -50px;
    }

    .el-message-box__btns {
      padding: 6px 20px 22px !important;
      gap: 12px !important;

      .el-button {
        width: 100px !important;
        height: 40px !important;
        font-size: 15px !important;
      }
    }
  }
  .opinion {
    .el-rate__item {
      font-size: 28px;
    }

    .el-textarea {
      height: 140px;

      .el-textarea__inner {
        font-size: 14px;
        padding: 10px 12px;
      }
    }

    #input-area::-webkit-input-placeholder {
      font-size: 13px;
    }
  }
}
</style>
